const RQ = {
    TRANSSACTIONS_LIST: "TRANSSACTIONS_LIST",
    DELETED_TRANSACTION: "DELETED_TRANSACTION",
    GET_METODOS_ES: "GET_METODOS_ES",
    GET_RESUMEN_TRANSACCIONES: "GET_RESUMEN_TRANSACCIONES",
    GET_REPORTE_TRANSACCIONES: "GET_REPORTE_TRANSACCIONES",
    GET_SALDOS: "GET_SALDOS"
}

export default RQ